export const getMonthlyCost = (option, includeInsurance) => {
    let value = includeInsurance ? option.monthly_cost_including_insurance:  option.monthly_cost;
    return Math.round(value);
}
export const getTotalCost = (option, includeInsurance) => {
    let value = includeInsurance ? option.monthly_cost_including_insurance:  option.monthly_cost;
    let total = value * option.contract_length;
    return Math.round(total);
}